import { client } from '../apiConfig'

const createThreadDraftAPI = (
  isInternal,
  subject,
  replyTo,
  body,
  toEmail,
  authorId
) => {
  return client.post(`/thread/draft/create`, {
    is_internal: isInternal,
    subject,
    'reply-to': replyTo,
    body,
    'to-email': toEmail,
    author_id: authorId,
  })
}

const sendThreadDraftAPI = (uuid) => {
  return client.put(`thread/draft/send/${uuid}`)
}

const updateThreadDraftAPI = (uuid, draftBody) => {
  return client.put(`/thread/draft/update/${uuid}`, draftBody)
}

const deleteThreadDraftAPI = (uuid) => {
  return client.delete(`/thread/draft/delete/${uuid}`)
}

const markReadMessageAPI = (uuid) => {
  return client.post(`/thread/markread/${uuid}`)
}

export {
  createThreadDraftAPI,
  sendThreadDraftAPI,
  updateThreadDraftAPI,
  markReadMessageAPI,
  deleteThreadDraftAPI,
}
